import ROUTES from '../routes/Routes';

export const buildURL = (route: ROUTES, urlParams?: Record<string, string>, queryParams?: Record<string, string>): string => {
	let url: string = route;
	if (urlParams) {
		Object.entries(urlParams).forEach(([key, value]) => {
			if (value) {
				url = url.replace(`:${key}`, value);
			}
		});
	}

	if (queryParams) {
		url = `${url}?`;
		Object.entries(queryParams).forEach(([key, value]) => {
			if (value) {
				url = `${url}${key}=${value}&`;
			}
		});

		// Remove trailing &
		url = url.substring(0, url.length - 1);
	}

	return url;
};
